<script lang="ts">
import { NotificationComponent } from "./notification-component.ts";
export default NotificationComponent;
</script>

<template>
    <div class="notification-component" v-if="model.initialized">
        <div class="notifications" id="notifications">
            <div @click="closeSidebar" class="notifications__overlay"></div>
            <div class="notifications__main">
                <div class="notifications__header">
                    <div
                        @click="openSidebar"
                        class="mobile-trigger-summary menu-trigger c-pointer"
                        :class="{
                            'mobile-trigger-summary_has-new':
                                model.totalUnreadNews.value !== 0,
                        }"
                    >
                        <span></span>
                    </div>
                    <div class="mobile-header-title" ref="test">
                        <i18n-t keypath="notifications.newsHighlights" />
                    </div>
                    <div
                        @click="$emit('update:active', false)"
                        class="mobile-notification-close c-pointer"
                    >
                        <svg class="sprite-icon">
                            <use xlink:href="/img/sprite.svg#close"></use>
                        </svg>
                    </div>
                    <a
                        @click.prevent="model.prev"
                        class="notifications__btn notifications__btn_prev"
                        :disabled="model.isFirstNotificationSelected.value"
                    >
                        <svg class="sprite-icon">
                            <use xlink:href="/img/sprite.svg#chevron-left"></use>
                        </svg>
                        <span><i18n-t keypath="notifications.prev" /></span>
                    </a>
                    <a
                        @click.prevent="model.next"
                        class="notifications__btn notifications__btn_next"
                        :disabled="model.isLastNotificationSelected.value"
                    >
                        <span><i18n-t keypath="notifications.next" /></span>
                        <svg class="sprite-icon">
                            <use xlink:href="/img/sprite.svg#chevron-right"></use>
                        </svg>
                    </a>
                    <div class="notifications__position">
                        <span class="prev">
                            {{ model.notificationDetailsIndex.value + 1 }}
                        </span>
                        <span class="slash">/</span>
                        <span class="all">
                            {{ model.notificationDetailsResponse.value?.total }}
                        </span>
                    </div>
                    <a
                        @click="model.hideNotificationDetails"
                        class="notifications__main-close"
                        href="#"
                    >
                        <svg class="sprite-icon">
                            <use xlink:href="/img/sprite.svg#close"></use>
                        </svg>
                        <span><i18n-t keypath="notifications.hideBtn" /></span>
                    </a>
                </div>
                <div class="notifications__body">
                    <div class="notifications__body-inner">
                        <notification-details
                            v-for="notificationDetail in model.notificationsDetailsData
                                .value"
                            :key="notificationDetail.id"
                            :active="
                                model.currentNotificationID.value ===
                                notificationDetail.id
                            "
                            :notificationDetails="notificationDetail"
                        />
                    </div>
                </div>
                <div class="notifications__footer">
                    <a
                        @click.prevent="model.prev"
                        class="notifications__btn notifications__btn_prev"
                        :disabled="model.isFirstNotificationSelected.value"
                    >
                        <svg class="sprite-icon">
                            <use xlink:href="/img/sprite.svg#chevron-left"></use>
                        </svg>
                        <span><i18n-t keypath="notifications.prev" /></span>
                    </a>
                    <div class="notifications__position">
                        <span class="prev">
                            {{ model.notificationDetailsIndex.value + 1 }}
                        </span>
                        <span class="slash">/</span>
                        <span class="all">
                            {{ model.notificationDetailsResponse.value?.total }}
                        </span>
                    </div>
                    <a
                        @click.prevent="model.next"
                        class="notifications__btn notifications__btn_next"
                        :disabled="model.isLastNotificationSelected.value"
                    >
                        <span><i18n-t keypath="notifications.next" /></span>
                        <svg class="sprite-icon">
                            <use xlink:href="/img/sprite.svg#chevron-right"></use>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="notifications__sidebar" :style="{ zIndex: 5 }">
                <button @click="closeSidebar" class="notifications__close">
                    <span><i18n-t keypath="notifications.closeBtn" /></span>
                    <svg class="sprite-icon">
                        <use xlink:href="/img/sprite.svg#close"></use>
                    </svg>
                </button>
                <div @click="closeSidebar" class="notifications-mobile__close-summary">
                    <svg class="sprite-icon">
                        <use xlink:href="/img/sprite.svg#close"></use>
                    </svg>
                </div>
                <div class="notifications__header">
                    <div class="notifications__header-title">
                        <i18n-t keypath="notifications.newsHighlights" />
                    </div>
                    <div
                        v-if="model.totalUnreadNews.value !== 0"
                        class="notifications__header-mark"
                    >
                        {{ model.totalUnreadNews.value }}
                    </div>
                </div>
                <div class="notifications__sidebar-inner">
                    <div class="notifications-summary overscroll">
                        <div
                            v-for="notificationDetail in model.notificationsDetailsData
                                .value"
                            :key="notificationDetail.id"
                            @click="model.showNotificationDetails(notificationDetail.id)"
                            class="notifications-summary__item"
                            :class="{
                                new: model.isNew(notificationDetail.id),
                                'is-active':
                                    model.currentNotificationID.value ===
                                    notificationDetail.id,
                            }"
                            ref="notificationItem"
                        >
                            <div class="h6 notifications-summary__title">
                                {{ notificationDetail.title }}
                            </div>
                            <p class="notifications-summary__text line-3-truncate">
                                {{ notificationDetail.content }}
                            </p>
                            <div class="notifications-summary__bottomline">
                                <a href="#">
                                    <i18n-t keypath="notifications.readMoreBtn" />
                                </a>
                                <span class="text-gray">
                                    {{
                                        model.formattedCreatedDate(
                                            notificationDetail.created_at,
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                        <button
                            style="width: 100%"
                            class="button"
                            v-if="model.canLoadMore.value"
                            @click="model.loadMore"
                            :disabled="model.isLoading.value"
                        >
                            <i18n-t keypath="notifications.loadMoreBtn" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
